import { useQuery } from 'react-query'
import { GeosearchRepository } from 'repository/geosearch'

export const useGeoserch = (query?: string, options?: any) => {
  const { status, data, error } = useQuery(
    !!query && ['geosearch', { query }],
    () => GeosearchRepository.geosearch(query!),
    { ...options },
  )

  return {
    status,
    results: data ? data : [],
    error: error as string,
  }
}
